import React, { useState } from 'react';
import AdminCRUD from '../../components/admin/AdminCRUD';
import I18nForm from '../../components/admin/I18nForm';

const CaseStudyForm = ({ initialData, onSave, onCancel }) => {
  const d = initialData || {};
  const [form, setForm] = useState({
    title:      d.title      || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    excerpt:    d.excerpt    || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    content:    d.content    || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    slug:       d.slug       || '',
    category:   d.category   || '',
    client:     d.client     || 'Confidential',
    isFeatured: d.isFeatured || false,
    isActive:   d.isActive !== false,
    results:    d.results    || [],
  });

  const inputStyle = { width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', color: '#334155', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  const addResult = () => setForm(f => ({ ...f, results: [...f.results, { value: '', metric: { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' } }] }));
  const removeResult = (i) => setForm(f => ({ ...f, results: f.results.filter((_, idx) => idx !== i) }));
  const updateResult = (i, field, val) => setForm(f => {
    const results = [...f.results];
    results[i] = { ...results[i], [field]: val };
    return { ...f, results };
  });

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(form); }}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
        <I18nForm label="Title" value={form.title} onChange={v => setForm(f => ({ ...f, title: v }))} />
        <div>
          <label style={labelStyle}>Slug</label>
          <input value={form.slug} onChange={e => setForm(f => ({ ...f, slug: e.target.value }))} required style={inputStyle} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
        <div>
          <label style={labelStyle}>Category</label>
          <input value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} required style={inputStyle} placeholder="Precision Manufacturing" />
        </div>
        <div>
          <label style={labelStyle}>Client</label>
          <input value={form.client} onChange={e => setForm(f => ({ ...f, client: e.target.value }))} style={inputStyle} />
        </div>
      </div>

      <I18nForm label="Excerpt" value={form.excerpt} onChange={v => setForm(f => ({ ...f, excerpt: v }))} multiline rows={2} />
      <I18nForm label="Content" value={form.content} onChange={v => setForm(f => ({ ...f, content: v }))} multiline rows={5} />

      {/* Results */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <label style={labelStyle}>Results Metrics</label>
          <button type="button" onClick={addResult} style={{ background: '#f0f9ff', color: '#3b82f6', border: 'none', borderRadius: '4px', padding: '4px 10px', fontSize: '12px', cursor: 'pointer' }}>+ Add Result</button>
        </div>
        {form.results.map((r, i) => (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: '100px 1fr 32px', gap: '8px', marginBottom: '8px', alignItems: 'start' }}>
            <div>
              <label style={{ ...labelStyle, fontSize: '10px' }}>Value</label>
              <input value={r.value} onChange={e => updateResult(i, 'value', e.target.value)} style={inputStyle} placeholder="280%" />
            </div>
            <I18nForm label="Metric Label" value={r.metric} onChange={v => updateResult(i, 'metric', v)} />
            <button type="button" onClick={() => removeResult(i)} style={{ alignSelf: 'flex-end', background: '#fef2f2', color: '#ef4444', border: 'none', borderRadius: '4px', padding: '8px', fontSize: '14px', cursor: 'pointer', marginBottom: '14px' }}>×</button>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', cursor: 'pointer' }}>
          <input type="checkbox" checked={form.isFeatured} onChange={e => setForm(f => ({ ...f, isFeatured: e.target.checked }))} />
          Featured
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', cursor: 'pointer' }}>
          <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))} />
          Active
        </label>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
        <button type="button" onClick={onCancel} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
};

const COLUMNS = [
  { key: 'title', label: 'Title (EN)', render: item => item.title?.en || '' },
  { key: 'category', label: 'Category' },
  { key: 'client', label: 'Client' },
  { key: 'isFeatured', label: 'Featured', render: item => item.isFeatured ? '⭐' : '' },
  { key: 'isActive', label: 'Active', render: item => item.isActive ? '✅' : '❌' },
];

const AdminCaseStudies = () => (
  <AdminCRUD
    title="Case Studies"
    apiPath="/api/admin/case-studies"
    columns={COLUMNS}
    FormComponent={CaseStudyForm}
  />
);

export default AdminCaseStudies;
